import styled from "styled-components";
import { DocumentPlusIcon, SquaresPlusIcon } from "@heroicons/react/24/outline";
import { Button } from "@sablier/v2-components/molecules";
import { useT } from "@sablier/v2-locales";
import { pages } from "~/client/constants";

const WrapperPartial = styled.div`
  grid-column: span 1;
`;

const Card = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 2);
    justify-content: center;
    width: 100%;
    min-height: 100%;
    padding: calc(${(props) => props.theme.sizes.edge} * 3);
    padding-inline: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
  }
`;

const Content = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 1);
    align-items: center;
    width: 100%;
  }
`;

const Title = styled.div`
  text-align: center;
  & > p {
    ${(props) => props.theme.styles.textElement}
  }
`;

const Description = styled.div`
  max-width: 80%;
  margin: 0 auto;
  text-align: center;
  & > p {
    ${(props) => props.theme.styles.textParagraph}
    & {
      color: ${(props) => props.theme.colors.gray400};
    }
  }
`;

const Footer = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    justify-content: center;
    width: 100%;
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxXL} {
    border-radius: 6px;
    background-color: ${(props) => props.theme.colors.dark200};
  }
  ${(props) => props.theme.medias.maxMD} {
    width: 100%;
    ${Card} {
      row-gap: calc(${(props) => props.theme.sizes.edge} * 1);
      width: 100%;
      height: 100%;
      padding: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
      ${Description} {
        max-width: 100%;
      }
    }
  }
`;

export interface Props {
  isGroup?: boolean;
}

function StreamCard({ isGroup = false }: Props) {
  const { t } = useT();
  return (
    <Wrapper>
      <Card>
        <Content>
          {isGroup ? (
            <>
              <Title>
                <p>{t("structs.individualsStreams")}</p>
              </Title>
              <Description>
                <p>{t("structs.hintSingle")}</p>
              </Description>
              <Footer>
                <Button
                  accent={"gray400"}
                  appearance={"transparent"}
                  isMini
                  title={t("structs.switchSingle")}
                  titleShort={t("words.individual")}
                  left={DocumentPlusIcon}
                  purpose={"internal"}
                  to={pages.gallery.builder()}
                />
              </Footer>
            </>
          ) : (
            <>
              <Title>
                <p>{t("structs.multipleStreams")}</p>
              </Title>
              <Description>
                <p>{t("structs.hintGroup")}</p>
              </Description>
              <Footer>
                <Button
                  accent={"gray400"}
                  appearance={"transparent"}
                  isMini
                  title={t("structs.switchGroup")}
                  titleShort={t("words.groups")}
                  left={SquaresPlusIcon}
                  purpose={"internal"}
                  to={pages.galleryGroup.builder()}
                />
              </Footer>
            </>
          )}
        </Content>
      </Card>
    </Wrapper>
  );
}

export default StreamCard;
